/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const ShowAnswerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 4.75C9.02441 4.75 6.34034 6.19366 4.40986 7.79323C3.44278 8.59454 2.65702 9.44123 2.11081 10.1791C1.83786 10.5478 1.62193 10.8931 1.47309 11.1953C1.32798 11.4899 1.23303 11.7702 1.23303 12.0005C1.23303 12.2308 1.32798 12.5111 1.47309 12.8057C1.62193 13.1078 1.83786 13.4532 2.11081 13.8219C2.65702 14.5598 3.44278 15.4064 4.40986 16.2077C6.34034 17.8073 9.02441 19.251 12 19.251C14.9757 19.251 17.6597 17.8073 19.5902 16.2077C20.5573 15.4064 21.3431 14.5598 21.8893 13.8219C22.1622 13.4532 22.3781 13.1078 22.527 12.8057C22.6721 12.5111 22.767 12.2308 22.767 12.0005C22.767 11.7702 22.6721 11.4899 22.527 11.1953C22.3781 10.8931 22.1622 10.5478 21.8893 10.1791C21.3431 9.44123 20.5573 8.59454 19.5902 7.79323C17.6597 6.19366 14.9757 4.75 12 4.75ZM12 17.6439C9.49736 17.6439 7.242 16.4137 5.57945 15.0615C4.75035 14.3871 4.07571 13.688 3.59959 13.1092C3.36143 12.8197 3.17483 12.5627 3.04404 12.356C2.93849 12.1892 2.87937 12.0707 2.85274 12.0005C2.87937 11.9303 2.93849 11.8118 3.04404 11.645C3.17483 11.4383 3.36143 11.1812 3.59959 10.8917C4.07571 10.313 4.75035 9.61387 5.57945 8.93952C7.242 7.58729 9.49736 6.35705 12 6.35705C14.5027 6.35705 16.7581 7.58729 18.4206 8.93952C19.2497 9.61387 19.9244 10.313 20.4005 10.8917C20.6386 11.1812 20.8252 11.4383 20.956 11.645C21.0616 11.8118 21.1207 11.9303 21.1473 12.0005C21.1207 12.0707 21.0616 12.1892 20.956 12.356C20.8252 12.5627 20.6386 12.8197 20.4005 13.1092C19.9244 13.688 19.2497 14.3871 18.4206 15.0615C16.7581 16.4137 14.5027 17.6439 12 17.6439Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M12.0001 7.68066C9.61775 7.68066 7.68005 9.61837 7.68005 12.0007C7.68005 14.383 9.61775 16.3207 12.0001 16.3207C14.3824 16.3207 16.3201 14.383 16.3201 12.0007C16.3201 9.61837 14.3824 7.68066 12.0001 7.68066ZM12.0001 14.7137C10.5044 14.7137 9.28711 13.4964 9.28711 12.0007C9.28711 10.505 10.5044 9.28772 12.0001 9.28772C13.4958 9.28772 14.7131 10.505 14.7131 12.0007C14.7131 13.4964 13.4958 14.7137 12.0001 14.7137Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  )
}
